import { useEffect } from 'react';

const SITE = 'https://crimsonscan.com';

function setMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function setCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', 'canonical');
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

// Per-route title, description and canonical for the public pages. The canonical
// lives only here (not in index.html), or every other route would point at the home page.
// The site is a
// single-page app, so without this every URL shares the homepage's head tags.
export default function usePageMeta({ title, description, path }) {
  useEffect(() => {
    const url = SITE + path;
    document.title = title;
    setMeta('name', 'description', description);
    setMeta('property', 'og:title', title);
    setMeta('property', 'og:description', description);
    setMeta('property', 'og:url', url);
    setMeta('name', 'twitter:title', title);
    setMeta('name', 'twitter:description', description);
    setCanonical(url);
    // Pages without this hook must not inherit another page's canonical.
    return () => document.head.querySelector('link[rel="canonical"]')?.remove();
  }, [title, description, path]);
}
